import { Route, Routes, Navigate } from 'react-router-dom';
import Contraintes from './Contraintes';
import Cooperative from './Cooperative';
import Tools from './Tools/Tools';
import AccesRightManager from './AccessRight/AccesRightManager';
import { useContext, useEffect } from 'react';
import { ExploitationContext } from 'utils/context';

const Administration = () => {
  const { setExploitationContext } = useContext(ExploitationContext);

  useEffect(() => {
    setExploitationContext(null);
  }, []);
  return (
    <div className="Administration">
      <Routes>
        <Route path="/" element={<Navigate to="Cooperative" />} />
        <Route path="Cooperative" element={<Cooperative />} />
        <Route path="Tools" element={<Tools />} />
        <Route path="accessRights" element={<AccesRightManager />} />
        <Route path="Contraintes" element={<Contraintes />} />
        <Route element={<Navigate to="/*" />} />
      </Routes>
    </div>
  );
};

export default Administration;
